import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchBalance } from 'shared/actions/user';
import { getDisplayName } from 'shared/helpers/common';

const withLeasingUIConditions = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withSearchPanel(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      // fetchBalance: PropTypes.func.isRequired,
      // isFetching: PropTypes.bool.isRequired,
      transport: PropTypes.shape().isRequired,
      prepaid: PropTypes.number,
      page: PropTypes.string,
      isNew: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
      brandToChose: PropTypes.shape(),
    };
    static defaultProps = {
      page: 'home',
      prepaid: null,
      isNew: null,
      brandToChose: null,
    };

    render() {
      const { page, prepaid, isNew, brandToChose, transport } = this.props;

      const pageName = page.toLowerCase();
      const leasingCarFormPages = ['search', 'home'];
      const collapsedAvaliableFor = ['search', 'home', 'spares', 'moto-search', 'commercial'];

      const ComponentsPanel = {
        dealers: 'dealers',
        spares: 'spares',
        'moto-search': 'moto',
        commercial: 'commercial',
      };
      const isAvto = transport && transport.id === 1;
      const showLeasingPrepayd = isAvto && leasingCarFormPages.includes(pageName);
      let showCityAndIsNew = !showLeasingPrepayd;
      let isCollapsed = collapsedAvaliableFor.includes(pageName);
      let showSearchButtons = true;
      let searchFormName = null;

      if (showLeasingPrepayd) {
        const showShortCarForm = !isNew && !!prepaid;
        const showDetailedForm = isNew || !!(brandToChose && brandToChose.id);

        if (showShortCarForm) searchFormName = 'leasingCar';
        else if (showDetailedForm) {
          searchFormName = ComponentsPanel[pageName] || 'car';
          showCityAndIsNew = true;
        } else searchFormName = null;

        showSearchButtons = showShortCarForm || showDetailedForm;
        isCollapsed = !showShortCarForm;
      } else {
        searchFormName = ComponentsPanel[pageName] || 'car';
      }

      return (
        <WrappedComponent
          {...this.props}
          showLeasingPrepayd={showLeasingPrepayd}
          showSearchButtons={showSearchButtons}
          showCityAndIsNew={showCityAndIsNew}
          isCollapsed={isCollapsed}
          searchFormName={searchFormName}
        />
      );
    }
  };

  const mapStateToProps = state => ({
    prepaid: state.searchForm.selected.prepaid,
    transport: state.searchForm.selected.transport,
    isNew: state.searchForm.selected.isNew,
    brandToChose: state.searchForm.data.brandToChose,
  });
  const mapDispatchToProps = {
    fetchBalance,
  };

  return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export default withLeasingUIConditions;



// WEBPACK FOOTER //
// ./src/shared/hocs/withLeasingUIConditions.js